export default function IconLogout() {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.83767 1.37903c-0.32322 -0.29792 -0.7589 -0.494114 -1.25072 -0.529122C7.66706 0.784431 6.71957 0.750244 5.75183 0.750244c-0.96774 0 -1.91524 0.034187 -2.83513 0.099666 -1.01224 0.072051 -1.78661 0.82687 -1.83233 1.74597C1.01375 4.01537 0.976562 5.48894 0.976562 7.00024c0 1.51131 0.037188 2.98487 0.107808 4.40436 0.04572 0.9191 0.82009 1.6739 1.83233 1.746 0.91989 0.0655 1.86739 0.0996 2.83513 0.0996 0.96774 0 1.91523 -0.0341 2.83512 -0.0996 0.49182 -0.035 0.9275 -0.2312 1.25072 -0.5291"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1"
			/>
			<path
				d="M4.53564 7.00002 13.3984 7"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1"
			/>
			<path
				d="M10.5547 4.15625c1.1375 0.56875 2.275 1.70625 2.8437 2.84371 -0.5687 1.13754 -1.7062 2.27504 -2.8437 2.84379"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1"
			/>
		</svg>
	);
}
